import React from "react";
import { FormattedMessage } from "react-intl";
import { v4 as uuid } from "uuid";
import { intlShape, userShape, planCartShape, addonsShape } from "../../shapes";
import { withConfiguration } from "../../context";
import PlanVariantAddonsGroup from "../PlanVariants/PlanVariantAddonsGroup";
import { withIntl, withUser } from "../../wrappers";
import { priceDisplayFormat } from "../../utils/priceUtils";

type Props = {
  planVariant?: {
    id?: string;
    currency?: string;
    name?: string;
    price?: string;
    type?: string;
    sort?: number;
    popular?: boolean;
    button?: string;
    assets?: number;
    storage?: number;
    short_description?: string;
    features?: string[];
    addons?: $TSFixMe[];
  };
  currentPlanVariant?: {
    id?: string;
    currency?: string;
    name?: string;
    price?: string;
    type?: string;
    sort?: number;
    popular?: boolean;
    button?: string;
    assets?: number;
    storage?: number;
    short_description?: string;
    features?: string[];
    addons?: $TSFixMe[];
  };
  planCart?: planCartShape;
  creating?: boolean;
  disabled?: boolean;
  currentAddons?: addonsShape;
  intl: intlShape;
  mode: "upgrade" | "current";
  onSelect: $TSFixMeFunction;
  configuration?: {
    planPriceDisplay?: string;
  };
  user: userShape;
};

function PaidPlan({
  planCart,
  planVariant,
  currentAddons,
  onSelect,
  disabled,
  intl,
  creating,
  configuration,
  user,
  mode,
  currentPlanVariant,
}: Props) {
  const [addons, setAddons] = React.useState();

  const addonQuantity = (addon: $TSFixMe) => {
    if (mode === "upgrade") {
      const currentPlanVariantAddons = currentPlanVariant?.addons;
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      const fullAddon = planVariant.addons.find(
        (pvAddon) => addon.id === pvAddon.id,
      );
      if (
        currentAddons &&
        currentPlanVariantAddons &&
        fullAddon.assets &&
        fullAddon.storage
      ) {
        const relevantCurrentAddons = currentAddons.filter(
          (currentAddon: $TSFixMe) =>
            currentPlanVariantAddons.find(
              (planAddon) => currentAddon.id === planAddon.id,
            ),
        );
        const currentAssetsCount =
          relevantCurrentAddons
            .map((currentAddon: $TSFixMe) => {
              const currentAddonAssets = currentPlanVariantAddons.find(
                (planAddon) => currentAddon.id === planAddon.id,
              ).assets;
              return currentAddonAssets
                ? currentAddonAssets * currentAddon.quantity
                : 0;
            })
            .reduce((sum: $TSFixMe, assets: $TSFixMe) => sum + assets, 0) +
          currentPlanVariant.assets;
        const currentStorageCount =
          relevantCurrentAddons
            .map((currentAddon: $TSFixMe) => {
              const currentAddonStorage = currentPlanVariantAddons.find(
                (planAddon) => currentAddon.id === planAddon.id,
              ).storage;
              return currentAddonStorage
                ? currentAddonStorage * currentAddon.quantity
                : 0;
            })
            .reduce((sum: $TSFixMe, storage: $TSFixMe) => sum + storage, 0) +
          currentPlanVariant.storage;
        const assetQuantity = Math.ceil(
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          (currentAssetsCount - planVariant.assets) / fullAddon.assets,
        );
        const storageQuantity = Math.ceil(
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          (currentStorageCount - planVariant.storage) / fullAddon.storage,
        );
        return Math.max(assetQuantity, storageQuantity) < 0
          ? 0
          : Math.max(assetQuantity, storageQuantity);
      }
    }

    if (currentAddons) {
      const foundMatchingAddon = currentAddons.find(
        (currentAddon: $TSFixMe) =>
          currentAddon.id === addon.id ||
          currentAddon.id === addon.id.replace("-premium", ""),
      );
      if (foundMatchingAddon) {
        return foundMatchingAddon.quantity;
      }
    }
    return null;
  };
  const setAddonsState = async () => {
    // Calculate the initial addons quantites for this plan, considering the plancart
    // its written to the state because the addon boxes also operate on the state, when quantities are changed by the user
    const addonsResult = {};
    // @ts-expect-error TS(2551) FIXME: Property 'plan_variant' does not exist on type 'pl... Remove this comment to see the full error message
    if (planCart?.plan_variant && planCart.plan_variant.id === planVariant.id) {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      planCart.addons.forEach((addon: $TSFixMe) => {
        // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        addonsResult[addon.plan_variant_addon.id] = addon.amount;
      });
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    } else if (currentAddons && planVariant.addons) {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      planVariant.addons.forEach((addon) => {
        // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        addonsResult[addon.id] = addonQuantity(addon);
      });
    }
    // @ts-expect-error TS(2345) FIXME: Argument of type '{}' is not assignable to paramet... Remove this comment to see the full error message
    setAddons(addonsResult);
  };

  if (!addons) {
    setAddonsState();
  }

  const handleMouseClick = (planVariantUsed: $TSFixMe) => {
    onSelect(planVariantUsed, addons);
  };

  const onAddonChange = (value: $TSFixMe, addon: $TSFixMe) => {
    // @ts-expect-error TS(2698) FIXME: Spread types may only be created from object types... Remove this comment to see the full error message
    const addonsResult = { ...addons };
    addonsResult[addon.id] = value;
    setAddons(addonsResult);
  };

  const calculateTotal = (plan = planVariant, addonsList = addons) => {
    // add up the total of the current plan configuration (using the addon quantites from the compononentes state)
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    let total = parseFloat(plan.price);
    if (addonsList) {
      Object.keys(addonsList).forEach((addonId) => {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        const planVariantAddon = plan.addons.find(
          (addon) => addon.id === addonId,
        );
        total += parseFloat(planVariantAddon.price) * addonsList[addonId];
      });
    }

    return total;
  };

  const isDirty = () => {
    let isDirtyValue = false;
    const selectedAddons = addons;
    if (currentAddons && currentAddons.length > 0 && selectedAddons) {
      Object.keys(selectedAddons).forEach((key) => {
        const correspondingCurrentAddon = currentAddons.find(
          (c: $TSFixMe) => c.id === key,
        );
        // @ts-expect-error TS(2322) FIXME: Type 'boolean | undefined' is not assignable to ty... Remove this comment to see the full error message
        isDirtyValue =
          isDirtyValue ||
          (!correspondingCurrentAddon && selectedAddons[key]) ||
          (correspondingCurrentAddon &&
            selectedAddons[key] !== correspondingCurrentAddon.quantity);
      });
    } else if (
      (!currentAddons || currentAddons.length === 0) &&
      selectedAddons &&
      Object.keys(selectedAddons).length > 0
    ) {
      isDirtyValue = Object.keys(selectedAddons).reduce(
        (prev, key) => prev || selectedAddons[key] > 0,
        false,
      );
    }

    return isDirtyValue ? true : false; // eslint-disable-line  no-unneeded-ternary
  };

  const addonsHeader =
    mode === "current" ? (
      <h3>
        <FormattedMessage id="upgradeplan.currentplan.upgrade_addons" />
      </h3>
    ) : null;

  const addonsSectionStyle =
    mode === "current" ? "panel-current-addon-upgrade" : null;

  const buttonDisabled = () => {
    if (mode === "current") {
      return !isDirty() || disabled;
    }
    return disabled;
  };

  const buttonLabel = () => {
    if (mode === "current") {
      return isDirty()
        ? intl.formatMessage({ id: "upgradeplan.currentplan.upgrade_now" })
        : intl.formatMessage({
            id: "upgradeplan.currentplan.currentplan_button",
          });
    }
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    return planVariant.button;
  };

  const totalLabel = () => {
    if (mode === "current") {
      return isDirty()
        ? intl.formatMessage({ id: "upgradeplan.currentplan.estimated_total" })
        : intl.formatMessage({ id: "upgradeplan.currentplan.current_total" });
    }
    return <FormattedMessage id="upgradeplan.currentplan.current_total" />;
  };

  const buttonStyle = () => {
    if (mode === "upgrade") {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      const highlightedPlan = currentPlanVariant.sort + 1 === planVariant.sort;
      return highlightedPlan
        ? "btn btn-primary select-button"
        : "btn select-button";
    }
    return "btn btn-primary select-button";
  };

  const panelStyle = () => {
    if (mode === "upgrade") {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      const highlightedPlan = currentPlanVariant.sort + 1 === planVariant.sort;
      return highlightedPlan ? "panel panel-primary" : "panel";
    }
    return "panel panel-current";
  };

  const panelClass = panelStyle();

  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const features = planVariant.features.map((item) => (
    <li className="list-item-checked" key={uuid()}>
      {item}
    </li>
  ));
  const planPriceDisplayYearly = configuration?.planPriceDisplay === "yearly";
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const planVariantPrice = parseFloat(planVariant.price);
  const planUnitText = intl.formatMessage({ id: "planvariant.per_user" });
  const displayPrice = priceDisplayFormat(
    intl,
    planVariantPrice,
    planPriceDisplayYearly,
    planVariant?.currency,
    planUnitText,
  );

  let price;
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  if (planVariant.name.toLowerCase().includes("fermentation")) {
    const yearlyPrice = parseFloat(
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      planVariant.addons.find((addon) => addon.type === "connectivity")?.price,
    );
    const fermentationUnitText = intl.formatMessage({
      id: "planvariant.per_qwx43",
    });
    price = priceDisplayFormat(
      intl,
      yearlyPrice,
      planPriceDisplayYearly,
      planVariant?.currency,
      fermentationUnitText,
    );
  } else {
    price =
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      planVariant.type === "free" || planVariantPrice === 0
        ? intl.formatMessage({ id: "planvariant.free" })
        : displayPrice;
  }

  const total = calculateTotal();
  const totalPrice = priceDisplayFormat(
    intl,
    total,
    planPriceDisplayYearly,
    planVariant?.currency,
    undefined,
  );
  const totalRendered = (
    <div className="plan-variant-total">
      <div className="plan-variant-total-header">{totalLabel()}</div>
      <div className="plan-variant-total-value">{totalPrice}</div>
      <div className="plan-variant-total-value-note">
        <FormattedMessage id="planvariant.billed_annually" />
      </div>
    </div>
  );

  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const addonsSection = planVariant.addons ? (
    // @ts-expect-error TS(2322) FIXME: Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
    <div className={addonsSectionStyle}>
      {addonsHeader}
      <PlanVariantAddonsGroup
        planVariant={planVariant}
        planCart={planCart}
        user={user}
        types={["outcome"]}
        titleId="planvariant.outcome"
        groupId="outcome"
        onAddonChange={onAddonChange}
        addonQuantity={addonQuantity}
        disabled={disabled}
        intl={intl}
      />
      <PlanVariantAddonsGroup
        planVariant={planVariant}
        planCart={planCart}
        user={user}
        types={["connectivity"]}
        titleId="planvariant.connectivity"
        groupId="connectivity"
        onAddonChange={onAddonChange}
        addonQuantity={addonQuantity}
        disabled={disabled}
        intl={intl}
      />
      <PlanVariantAddonsGroup
        planVariant={planVariant}
        planCart={planCart}
        user={user}
        types={["process_insights"]}
        titleId="planvariant.process_insights"
        groupId="process-insights"
        onAddonChange={onAddonChange}
        addonQuantity={addonQuantity}
        disabled={disabled}
        intl={intl}
      />
      <PlanVariantAddonsGroup
        planVariant={planVariant}
        planCart={planCart}
        user={user}
        types={["addon", "extension"]}
        titleId="planvariant.addons"
        groupId="standard"
        onAddonChange={onAddonChange}
        addonQuantity={addonQuantity}
        disabled={disabled}
        intl={intl}
      />
      <div>{totalRendered}</div>
    </div>
  ) : null;

  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const shortDescription = planVariant.short_description ? (
    <div id="short-description" className="space-after short-description">
      {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
      {planVariant.short_description}
    </div>
  ) : null;

  const spinner = creating ? <i className="btn-spinner" /> : null;

  return (
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    <div id={`plan-variant-${planVariant.id}`} className={panelClass}>
      <div className="panel-heading">
        <div className="title">
          {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
          {planVariant.name}
          <div id="price" className="panel-subtitle">
            {price}
          </div>
          {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
          {planVariant.type === "free" || planVariantPrice === 0 ? null : (
            <p className="panel-subtitle">
              {intl.formatMessage({ id: "planvariant.billed_annually" })}
            </p>
          )}
        </div>
      </div>
      <div className="panel-body">
        <div className="panel-current-selection">
          {shortDescription}
          <ul id="plan-variant-features" className="list-checked">
            {features}
          </ul>
        </div>
        {addonsSection}
      </div>
      <div className="panel-footer">
        <button
          type="button"
          disabled={buttonDisabled()}
          onMouseDown={() => handleMouseClick(planVariant)}
          className={buttonStyle()}
        >
          {buttonLabel()}
          {spinner}
        </button>
      </div>
    </div>
  );
}

export default withConfiguration(withUser(withIntl(PaidPlan)));
